<template>
  <div>
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
      <div class="loading-spinner-outer" v-if="deleting">
          <div class="loading-spinner-inner">
              <div class="loading-spinner"></div>
              <div class="loading-spinner-content">
                  Deleting, please wait
              </div>
          </div>
      </div>
    <div class="box">
      <div class="box-content">
        <div class="flex-2xs mb-3 justify-end">
          <div class="pr-3-2xs pb-1 pb-0-2xs">
            <a class="btn-primary" href="/company/create">
              Add New
            </a>
          </div>
            <div class="pr-3-2xs pb-1 pb-0-2xs">
              <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open, areas_supplied_filter_open = false, commercial_areas_supplied_filter_open = false, advanced_search_box_open = false" style="min-width:275px;">
                <div class="multi-select-input-placeholder">
                  Filter...
                  <div class="dropdown-icon">
                    <i class="fal fa-chevron-down"></i>
                  </div>
                </div>
                <div class="multi-select-input-inner" v-show="filter_dropdown_open">
                  <div class="multi-select-input-group">
                    <h1 class="input-group-title">Company Types</h1>
                    <div class="checkboxes">
                      <div class="checkbox level-1" v-for="company_type in all_company_types">
                        <label>
                          <input type="checkbox" name="company_types" :value="company_type.id" v-model="selected_company_types">
                          <span class="checkbox-label">{{ company_type.label }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="multi-select-input-group mt-3">
                    <h1 class="input-group-title">System Types</h1>
                    <div class="checkboxes">
                      <div class="checkbox level-1" v-for="system_type in all_system_types">
                        <label>
                          <input type="checkbox" name="company_types" :value="system_type.id" v-model="selected_system_types">
                          <span class="checkbox-label">{{ system_type.label }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="multi-select-input-group mt-3">
                    <h1 class="input-group-title">Deleted Companies</h1>
                    <div class="checkboxes">
                      <div class="checkbox level-1">
                        <label>
                          <input type="checkbox" name="show_deleted_users" :value="'deleted'" v-model="show_deleted_companies">
                          <span class="checkbox-label">Show Deleted Companies</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="multi-select-input-group mt-3">
                    <h1 class="input-group-title">Activated</h1>
                    <div class="checkboxes">
                      <div class="checkbox level-1">
                        <label>
                          <input type="checkbox" name="user_activated_filter" :value="'Yes'" v-model="user_activated_filter">
                          <span class="checkbox-label">Yes</span>
                        </label>
                      </div>
                      <div class="checkbox level-1">
                        <label>
                          <input type="checkbox" name="user_activated_filter" :value="'No'" v-model="user_activated_filter">
                          <span class="checkbox-label">No</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="multi-select-input-group mt-3">
                    <h1 class="input-group-title">Has Showroom</h1>
                    <div class="checkboxes">
                      <div class="checkbox level-1">
                        <label>
                          <input type="checkbox" name="has_showroom" :value="true" v-model="has_showroom_filter">
                          <span class="checkbox-label">Yes</span>
                        </label>
                      </div>
                      <div class="checkbox level-1">
                        <label>
                          <input type="checkbox" name="has_showroom" :value="false" v-model="has_showroom_filter">
                          <span class="checkbox-label">No</span>
                        </label>
                      </div>
                      <div class="checkbox level-1">
                        <label>
                          <input type="checkbox" name="has_showroom" value="'not-set-up'" v-model="has_showroom_filter">
                          <span class="checkbox-label">Not set up</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <div class="pr-3-2xs pb-1 pb-0-2xs">
            <div class="input-group">
              <input type="text" placeholder="Search" class="form-control" v-model="search_query">
              <div class="input-group-addon" @click="advanced_search_box_open = !advanced_search_box_open, filter_dropdown_open = false, areas_supplied_filter_open = false, commercial_areas_supplied_filter_open = false"><i class="fal fa-cog"></i>
                <i class="fal fa-chevron-down" v-if="!advanced_search_box_open"></i>
                <i class="fal fa-chevron-up" v-if="advanced_search_box_open"></i>
              </div>
            </div>
          </div>
          <div>
            <div class="btn-primary" @click="areas_supplied_filter_open = !areas_supplied_filter_open, advanced_search_box_open = false, filter_dropdown_open = false">
              Areas Supplied
              <i class="fal fa-chevron-down" v-if="!areas_supplied_filter_open"></i>
              <i class="fal fa-chevron-up" v-if="areas_supplied_filter_open"></i>
            </div>
          </div>
          <div>
            <div class="btn-primary" @click="commercial_areas_supplied_filter_open = !commercial_areas_supplied_filter_open, advanced_search_box_open = false, filter_dropdown_open = false, areas_supplied_filter_open = false">
              Commercial Areas Supplied
              <i class="fal fa-chevron-down" v-if="!commercial_areas_supplied_filter_open"></i>
              <i class="fal fa-chevron-up" v-if="commercial_areas_supplied_filter_open"></i>
            </div>
          </div>
        </div>
        <div class="box _bordered p-3 mb-3" v-show="areas_supplied_filter_open" style="box-shadow: none;">
          <div class="checkboxes" style="display: flex; flex-wrap: wrap; flex-direction: row;">
            <label class="checkbox" v-for="postcode_prefix in postcode_prefixes" style="width: 80px; padding: 5px;">
              <input type="checkbox" v-model="areas_supplied_filter" :value="postcode_prefix.id">
              <span class="checkbox-label"> {{ postcode_prefix.postcode_prefix }} </span>
            </label>
          </div>
        </div>
        <div class="box _bordered p-3 mb-3" v-show="commercial_areas_supplied_filter_open" style="box-shadow: none;">
          <div class="checkboxes" style="display: flex; flex-wrap: wrap; flex-direction: row;">
            <label class="checkbox" v-for="postcode_prefix in postcode_prefixes" style="width: 80px; padding: 5px;">
              <input type="checkbox" v-model="commercial_areas_supplied_filter" :value="postcode_prefix.id">
              <span class="checkbox-label"> {{ postcode_prefix.postcode_prefix }} </span>
            </label>
          </div>
        </div>
        <div class="box _bordered p-3 mb-3" v-show="advanced_search_box_open" style="box-shadow: none;">
          <div class="flex">
            <div class="mt-3 pr-3">
              Search&nbsp;On:
            </div>
            <div class="radios _inline">
              <label class="radio">
                <input type="radio" v-model="search_on" value="company_name">
                <span class="radio-label"> Company Name </span>
              </label>
              <label class="radio">
                <input type="radio" v-model="search_on" value="account_code">
                <span class="radio-label"> Account Code </span>
              </label>
              <label class="radio">
                <input type="radio" v-model="search_on" value="address_town">
                <span class="radio-label"> Town </span>
              </label>
              <label class="radio">
                <input type="radio" v-model="search_on" value="address_county">
                <span class="radio-label"> County </span>
              </label>
              <label class="radio">
                <input type="radio" v-model="search_on" value="address_postcode">
                <span class="radio-label"> Full Postcode </span>
              </label>
              <label class="radio">
                <input type="radio" v-model="search_on" value="address_postcode_prefix">
                <span class="radio-label"> Postcode Prefix </span>
              </label>
              <label class="radio">
                <input type="radio" v-model="search_on" value="address_distance">
                <span class="radio-label"> Address Distance </span>
              </label>
              <label class="radio">
                <input type="radio" v-model="search_on" value="showroom_distance">
                <span class="radio-label"> Showroom Distance </span>
              </label>
            </div>
          </div>
        </div>
        <div class="relative">
          <div class="filtering-overlay" v-show="filtering">
            <div v-if="invalid_postcode" class="alert-danger align-center mt-3">
              Invalid Postcode ({{ search_query }})
            </div>
            <div class="p-3 align-center mt-3">
              Filtering...
            </div>
          </div>
          <template v-if="!loading && total_count > 0">
            <table class="table_list">
              <thead>
              <tr>
                <th>Date Added</th>
                <th>Company Type</th>
                <th>Account Code</th>
                <th>Company Name</th>
                <th style="width: 100px; text-align: center;">Showroom</th>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(company, index) in companies">
                <tr>
                  <td>{{ company.formatted_created_at }}</td>
                  <td>
                    {{ company.company_type.label }}
                  </td>
                  <td>
                    {{ company.account_code }}
                  </td>
                  <td>
                    <a :href='"/company/"+company.id' v-if="company.deleted_at === null">{{ company.name }}</a>
                    <span v-if="company.deleted_at !== null">{{ company.name }}</span>
                  </td>
                  <td class="align-center">
                    <template v-if="company.rebrand_info_submitted">
                      <i v-if="company.has_showroom" class="fal fa-check txt-positive"></i>
                      <i v-if="!company.has_showroom" class="fal fa-times"></i>
                    </template>
                    <template v-else>
                      <span class="txt-warning">--</span>
                    </template>
                  </td>
                  <td class="td_view">
                    <a :href='"/company/"+company.id' class="txt-primary" v-if="company.deleted_at === null">
                      <i class="fa fa-eye"></i>
                    </a>
                  </td>
                  <td class="td_more-options">
                    <a class="txt-primary" @click="toggleMoreOptionsDropdown(company.id)">
                      ...
                    </a>
                    <div v-show="more_options_dropdown_open_for === company.id" class="td_more-options-dropdown-wrapper">
                      <template v-if="company.deleted_at === null">
                        <a @click="exportCompanyFull(company)">
                          <i class="fa fa-envelope txt-primary"></i> Export Company
                        </a>
                        <a @click.prevent="deleteCompany(company.id)" class="txt-danger cursor-pointer" v-if="company.deleted_at === null">
                          <i class="fa fa-trash"></i> Delete Company
                        </a>
                      </template>
                      <template v-else>
                        <a @click="restoreCompany(company.id)" class="txt-positive cursor-pointer" v-if="company.deleted_at !== null">
                          <i class="fa fa-trash-undo"></i> Restore Company
                        </a>
                      </template>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="7">
                    <template v-if="company.addresses.length > 0">
                      <div class="flex justify-between txt-light txt-sm mb-1" v-for="(address, index) in company.addresses">
                        <div>
                          <a :href='`/company/${company.id}/address/${address.id}`' class="txt-primary">
                            <i class="fa fa-eye"></i>
                          </a>
                          {{ showAddress(address) }}
                        </div>
                        <div>
                          {{ address.postcode }}
                        </div>
                      </div>
                    </template>
                    <template v-if="company.showrooms.length > 0">
                      <div class="flex justify-between txt-light txt-sm mb-1" v-for="(showroom, index) in company.showrooms">
                        <div>
                          <a :href='`/company/${company.id}/showrooms/${showroom.id}`' class="txt-primary">
                            <i class="fa fa-eye"></i>
                          </a>
                          Showroom: {{ showAddress(showroom) }}
                        </div>
                        <div>
                          {{ showroom.postcode }}
                        </div>
                      </div>
                    </template>
                    <div class="txt-italic txt-light txt-sm" v-if="company.showrooms.length === 0 && company.addresses.length === 0">
                      Company has no addresses or showrooms
                    </div>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </template>
        </div>
        <div class="pagination-bar wrapper mb-3 mt-3">
          <div class="row">
            <div class="col">
              <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                  class="fa fa-caret-left"></i></a>
              <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
              <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                 class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
            </div>
            <div class="col align-right">
              <div class="mt-1 mb-1">
                {{ total_count }} results found
              </div>
            </div>
          </div>
        </div>
        <template v-if="!loading && !filtering && total_count === 0">
          <strong>
            No Results Found
          </strong>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'postcode_prefixes',
    'all_company_types',
    'all_system_types',
  ],
  mounted() {
    if(window.location.hash) {
      this.current_page = window.location.hash.substring(1);
    }
    this.loadCompanies();
  },
  data() {
    return {
      companies: [],
      search_query: '',
      selected_company_types: [],
      selected_system_types: [],
      current_page: 1,
      total_count: 0,
      total_pages: 0,
      limit: 20,
      loading: true,
      deleting: false,
      filter_dropdown_open: false,
      filtering: false,
      show_deleted_companies: false,
      areas_supplied_filter_open: false,
      areas_supplied_filter: [],
      commercial_areas_supplied_filter_open: false,
      commercial_areas_supplied_filter: [],
      advanced_search_box_open: false,
      user_activated_filter: [],
      has_showroom_filter: [],
      search_on: 'company_name',
      invalid_postcode: false,
      northings: null,
      eastings: null,
      more_options_dropdown_open_for: null,
    }
  },
  methods: {
    loadCompanies: _.debounce(function () {
      this.invalid_postcode = false;
      axios.post('/company/loadCompanies', {
        page_number: this.current_page,
        search_query: this.search_query,
        selected_company_types: this.selected_company_types,
        selected_system_types: this.selected_system_types,
        show_deleted_companies: this.show_deleted_companies,
        has_showroom_filter: this.has_showroom_filter,
        areas_supplied_filter: this.areas_supplied_filter,
        commercial_areas_supplied_filter: this.commercial_areas_supplied_filter,
        user_activated_filter: this.user_activated_filter,
        search_on: this.search_on,
        limit: this.limit,
        northings: this.northings,
        eastings: this.eastings,
      }).then((response) => {
        this.companies = response.data.data;
        this.total_count = response.data.total;
        this.total_pages = response.data.last_page;
        this.loading = false;
        this.filtering = false;
      });
    }, 250),
    prevPage() {
      this.current_page = this.current_page - 1;
      this.setPageHash();
      this.loadCompanies();
    },
    nextPage() {
      this.current_page = this.current_page + 1;
      this.setPageHash();
      this.loadCompanies();
    },
    deleteCompany(id) {
      Swal.fire({
        title: 'Are you sure you want to remove this company?',
        text: 'This will delete the company, addresses, and disable the accounts for all company contacts.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleting = true;
          axios.post('/company/delete', {
            'company_id': id,
          }).then((response) => {
            this.current_page = 1;
            this.setPageHash();
            this.loadCompanies();
            this.deleting = false;
            Swal.fire({
              title: 'Company Deleted',
              icon: 'success',
            });
          });
        }
      });
    },
    restoreCompany(id) {
      Swal.fire({
        title: 'Are you sure you want to restore this company?',
        text: 'This will restore the company, their addresses and all customers.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleting = true;
          axios.post('/company/restore', {
            'company_id': id,
          }).then((response) => {
            this.current_page = 1;
            this.setPageHash();
            this.loadCompanies();
            this.deleting = false;
            Swal.fire({
              title: 'Company Restored',
              icon: 'success',
            });
          });
        }
      });
    },
    setPageHash() {
      window.location = `#${this.current_page}`;
    },
    showAddress(address) {
      const address_lines = [
        address.line_1,
        address.line_2,
        address.town,
        address.county,
      ];
      return address_lines.filter(Boolean).join(', ');
    },
    checkPostcodeAndSearchCompanies: _.debounce(function () {
      this.filtering = true;
      if(this.search_on === "address_distance" || this.search_on === "showroom_distance" || this.search_on === "address_postcode") {
        axios.post('getPostcodeInfo', {
          'postcode': this.search_query,
        }).then((response) => {
          this.northings = response.data.result.northings;
          this.eastings = response.data.result.eastings;
          this.searchCompanies();
        }).catch((error) => {
          this.invalid_postcode = true;
        });
      } else {
        this.searchCompanies();
      }
    }, 250),
    searchCompanies() {
      this.filtering = true;
      this.current_page = 1;
      this.setPageHash();
      this.loadCompanies();
    },
    exportCompanyFull(company) {
      axios({
        url: '/company/exportCompanyFull',
        method: 'POST',
        responseType: 'blob',
        data: {
          company_id: company.id,
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', company.name+' Export.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
    toggleMoreOptionsDropdown(company_id) {
      if (this.more_options_dropdown_open_for === company_id) {
        this.more_options_dropdown_open_for = null;
      } else {
        this.more_options_dropdown_open_for = company_id;
      }
    },
  },
  watch: {
    search_query() {
      this.checkPostcodeAndSearchCompanies();
    },
    selected_company_types() {
      this.checkPostcodeAndSearchCompanies();
    },
    selected_system_types() {
      this.checkPostcodeAndSearchCompanies();
    },
    show_deleted_companies() {
      this.checkPostcodeAndSearchCompanies();
    },
    user_activated_filter() {
      this.checkPostcodeAndSearchCompanies();
    },
    has_showroom_filter() {
      this.checkPostcodeAndSearchCompanies();
    },
    areas_supplied_filter() {
      this.checkPostcodeAndSearchCompanies();
    },
    commercial_areas_supplied_filter() {
      this.checkPostcodeAndSearchCompanies();
    },
    search_on() {
      this.checkPostcodeAndSearchCompanies();
    },
  },
};
</script>
